(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('TermsAndServiceController', TermsAndService);

  /** @ngInject */
  function TermsAndService(
    $timeout,
    $sce,
    $location,
    $anchorScroll,
    userActions,
    sessionData,
    $stateParams,
    helperService,
    checkUserRole,
    $state,
    $window
  ) {
    var vm = this;
    var marker = $stateParams.marker;

    vm.termsOfService = null;
    vm.termsNeedToBeAccepted = false;

    vm.acceptTerms = function() {
      userActions
        .acceptTermsOfServiceDocument()
        .then(function (response) {
          helperService.setUserDataToLocalStorageOnLogIn(response.data);
          $state.go("app.dashboardTechnology", {}, {reload: true});
          $window.location.reload();
        });
    };

    activate();

    function activate() {
      setTermsAcceptanceStatus();
      loadTermsDocument();
    }

    function setTermsAcceptanceStatus() {
      var userRole = sessionData.getValue('userRole');
      vm.termsNeedToBeAccepted = checkUserRole.hasAcceptNewTerms(userRole);
    }

    function loadTermsDocument() {
      var countryCode = sessionData.getValue('countryIsoCode');
      var language = sessionData.getValue('language');

      userActions
        .getTermsOfServiceDocument(countryCode, language)
        .then(function (data) {
          vm.termsOfService = $sce.trustAsHtml(data || '<p>No data to display. Missing document.</p>');

          if (marker) {
            $timeout(function() {
              $location.hash(marker);
              $anchorScroll();
            });
          }
        });
    }
  }
})();
